import { usersManagementApi } from 'app/services/api';

import { DeletedUsersPolicy, UserSearchField } from 'constants/userSearch';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const ROLE_USERS_ACTION_TYPE = createNamedActions('roleUsers', {
  GET_ROLE_USERS: 'GET_ROLE_USERS',
  SAVE_ROLE_USERS: 'SAVE_ROLE_USERS',
  TOGGLE_ROLE_FOR_USERS: 'TOGGLE_ROLE_FOR_USERS',
  DELETE_ROLE_USERS: 'DELETE_ROLE_USERS',
});

export const getRoleUsersAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await usersManagementApi.searchUsers({
    fields: [UserSearchField.ID],
    filter: {
      companyId: params.companyId,
      roleIds: [params.id],
      excludeSubCompanyUsers: true,
      deletedPolicy: DeletedUsersPolicy.EXCLUDE_DELETED,
    },
  });

  return dispatch({
    type: ROLE_USERS_ACTION_TYPE.GET_ROLE_USERS,
    payload: data.items.map(({ id }) => id),
  });
});

export const saveRoleUsersAction = catchAsyncActionError(
  ({ companyId, type, roleId, usersIds }) =>
    async dispatch => {
      const params = { companyId, data: usersIds.map(userId => ({ userId, roleId, type })) };

      await usersManagementApi.createUserRoleAssignmentsMultiple(params);

      return dispatch({ type: ROLE_USERS_ACTION_TYPE.SAVE_ROLE_USERS });
    },
);

export const deleteRoleUsersAction = catchAsyncActionError(
  ({ companyId, type, roleId, usersIds }) =>
    async dispatch => {
      const params = { companyId, data: usersIds.map(userId => ({ userId, roleId, type })) };

      await usersManagementApi.deleteUserRoleAssignmentsMultiple(params);

      return dispatch({ type: ROLE_USERS_ACTION_TYPE.DELETE_ROLE_USERS });
    },
);

export const toggleRoleForUserAction = params => dispatch =>
  dispatch({
    type: ROLE_USERS_ACTION_TYPE.TOGGLE_ROLE_FOR_USERS,
    payload: params.userId,
  });
